module.exports = __webpack_public_path__ + "static/img/temp-pc-contents01@t.3268880.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ezn-foundation/temp-pc-contents01@t.jpg
// module id = p53y
// module chunks = 0